
<dx-drawer
  #fullDrawer
  [closeOnOutsideClick]="fullDrawer.opened"
  [openedStateMode]="'overlap'"
  [opened]="!onlyIconSidenav"
  [revealMode]="'expand'"
  [shading]="true"
  class="sidenav-container fullDrawer"
  template="template">

  <div *dxTemplate="let data of 'template'" [style.height.px]="window.innerHeight"
       class="drawerInnerContent sidenav"
       style="width: 250px; background: var(--dx-color-main-bg)">
    <div style="display: flex; flex-direction: column; height: 100%; width: 250px; padding: 0 5px">
      <div class="flexRow" style="margin: 0 8px; justify-content: space-between">
        <div style="flex: 1 1 0">
          <dx-button
            style="z-index: 1"
            (onClick)="fullDrawer.opened = false"
            [stylingMode]="'text'">
            <i class="vr-ic_fluent_navigation_24_regular"></i>
          </dx-button>
        </div>
        <div class="sidenavContent sidenavLogoContainer" style="padding: 0">
          <div style="
        display: flex;
        align-items: center;
        height: 100%;
        width: auto;">
            <img *ngIf="!appService.isDarkTheme"
                 alt="innteaLogo"
                 class="unselectable"
                 height="240"
                 ngSrc="../../../assets/keton-logo-top-bar.png" priority style="
           object-fit: contain;
           height: 60px;
           width: auto;" width="380"/>
            <img *ngIf="appService.isDarkTheme"
                 alt="innteaLogo"
                 class="unselectable"
                 height="240"
                 ngSrc="../../../assets/keton-logo-top-bar-2.png" priority style="
           object-fit: contain;
           height: 60px;
           width: auto;" width="380"/>
          </div>
        </div>
          <div style="flex: 1 1 0">
            <!-- SPACER -->
          </div>
      </div>
      <dx-scroll-view
        [showScrollbar]="'always'"
        [width]="'100%'">
        <div *ngFor="let item of gmService.user.menuItems | orderBy: 'orderIndex'"
             [class]="item.id === appService.menuGroup?.id ? 'sidenav-grp grp-selected' : 'sidenav-grp'">

          <div (click)="item.isOpen = !item.isOpen"
               [class]="item.id === appService.menuGroup?.id ? 'sidenavContent item-selected' : 'sidenavContent'"
               class="unselectable sidenavContent">
            <p class="noMargin">{{ ('MENU_GRP.' + item.name | translate).toUpperCase() }}</p>
            <i *ngIf="!item.isOpen" class="vr-ic_fluent_chevron_right_24_regular"
               style="font-size: 16px; padding: 0 7px"></i>
            <i *ngIf="item.isOpen" class="vr-ic_fluent_chevron_down_24_regular"
               style="font-size: 16px; padding: 0 7px"></i>
          </div>

          <div *ngIf="item.isOpen">
            <div (click)="clickAndClose(item, voice, fullDrawer)"
                 *ngFor="let voice of item.voices | orderBy: 'orderIndex'"
                 [class]="voice.id === appService.menuVoice?.id ? 'sidenav-item voice-selected' : 'sidenav-item'">
              <div class="unselectable">
                <div style="display: flex;">
                  <i
                    class="{{getIconName(voice.iconName, voice.id === appService.menuVoice?.id)}}"></i>
                  <span
                    [class]="voice.id === appService.menuVoice?.id ? 'sidenavVoiceContentSelected' : 'sidenavVoiceContent'">
                    {{ 'MENU_VOICE.' + item.name + '.' + voice.name.toUpperCase() | translate }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </dx-scroll-view>
      <div class="flexFill"></div>


      <div style="display: flex; flex-direction: column;">
        <div style="display: flex; align-items: center" class="sidenav-item unselectable" (click)="toggleHeadway($event)">
          <span id="hw-slot-full" style="position: relative; display: inline-flex; align-items: center">
            <i class="vr-ic_fluent_megaphone_24_regular"></i>
          </span>
          <span class="sidenavVoiceContent">{{ 'HEADWAY.NEWS' | translate }}</span>
        </div>
        <dx-button
          (onClick)="onlyIconSidenav = !onlyIconSidenav"
          *ngIf="!appService.isSmallScreen()"
          [disabled]="editMode"
          [width]="'100%'"
          stylingMode="text">
          <i class="vr-ic_fluent_chevron_left_24_regular"
             style="color: var(--dx-texteditor-color-label); font-size: 16px"></i>
        </dx-button>
      </div>

      <!-- ******************************* -->
      <!--              LOGO               -->
      <!-- ******************************* -->

      <div class="sidenavImageContainer">
        <span><em>Powered by</em></span>
        <a class="unselectable sidenavImageContainer" href="https://inntea.it" target="_blank">
          <img *ngIf="appService.isDarkTheme"
               alt="innteaLogoDark"
               class="orizImg"
               height="43" ngSrc="../../../assets/INNTEA_logo_ORIZ_white.svg" width="152"/>
          <img *ngIf="!appService.isDarkTheme"
               alt="innteaLogoLight"
               class="orizImg"
               height="43" ngSrc="../../../assets/INNTEA_logo_ORIZ.svg" width="152"/>
        </a>
      </div>
    </div>
  </div>

  <app-topbar (goToRequest)="topbarGoTo($event)" (toggleDrawer)="toggleCurrentDrawer(fullDrawer, iconDrawer)"
              [componentName]="selectedPageName" [disabled]="editMode" class="toolbar"></app-topbar>

  <dx-drawer
    #iconDrawer
    (openedChange)="dispatchSizeRefreshEvent()"
    [closeOnOutsideClick]="false"
    [openedStateMode]="'shrink'"
    [opened]="onlyIconSidenav && !appService.isSmallScreen()"
    [revealMode]="'expand'"
    class="sidenav-container absoluteFillAfterTopbar iconDrawer"
    template="template">
    <div *dxTemplate="let data of 'template'" class="drawerInnerContent sidenav iconOnly"
         style="height: 100%; background: var(--dx-color-main-bg)">
      <div style="display: flex; flex-direction: column; height: 100%; align-items: center">

        <dx-scroll-view
          [showScrollbar]="'always'"
          [width]="'100%'">
          <div *ngFor="let item of gmService.user.menuItems | orderBy: 'orderIndex'"
               [class]="item.id === appService.menuGroup?.id ? 'flexColumn sidenav-grp grp-selected' : 'flexColumn sidenav-grp'">
            <div *ngFor="let voice of item.voices | orderBy: 'orderIndex'">
              <dx-button
                (onClick)="clickNoClose(item,voice)"
                [disabled]="editMode"
                hint="{{'MENU_VOICE.' + item.name + '.' + voice.name.toUpperCase() | translate}}"
                stylingMode="text">
                <div [ngClass]="voice.id === appService.menuVoice?.id ? 'voice-selected' : ''">
                  <i
                    class="{{getIconName(voice.iconName, voice.id === appService.menuVoice?.id)}}"></i>
                </div>
              </dx-button>
            </div>
          </div>
        </dx-scroll-view>
        <div class="flexFill"></div>
        <dx-button
          style="min-height: 32px; overflow: visible; margin-bottom: 6px;"
          [hint]="'HEADWAY.NEWS' | translate"
          stylingMode="text"
          (onClick)="toggleHeadway($event.event)">
          <div id="hw-slot-icon">
            <i class="vr-ic_fluent_megaphone_24_regular"></i>
          </div>
        </dx-button>
        <dx-button
          (onClick)="onlyIconSidenav = !onlyIconSidenav"
          *ngIf="!appService.isSmallScreen()"
          [disabled]="editMode"
          stylingMode="text">
          <i class="vr-ic_fluent_chevron_right_24_regular"
             style="color: var(--dx-texteditor-color-label); font-size: 16px"></i>
        </dx-button>
        <a class="unselectable flexColumn" href="https://inntea.it" target="_blank">
          <img
            alt="innteaLogo"
            height="63"
            ngSrc="../../../assets/INNTEA_logo_spiral_only.svg"
            style="width: 60px;height: auto;object-fit: contain;padding: 8px 10px;" width="62"/>
        </a>
      </div>
    </div>


    <div class="sidenavMainContent">
      <div class="fullPageMainContent">
        <div class="absoluteFill insetShadow" [ngClass]="onlyIconSidenav && !appService.isSmallScreen()? 'onlyIconSidenav' : 'fullSidenav'">
          <router-outlet [style.opacity]="loadingPage? 0 : 1"></router-outlet>
        </div>
      </div>

    </div>
  </dx-drawer>

</dx-drawer>
